"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORK_ORDER_BID_ACCEPTED_STATUS = exports.WORK_ORDER_BID_STATUS = void 0;
exports.WORK_ORDER_BID_STATUS = {
    INITIATED: 'Initiated',
    WORK_ORDER_SENT: 'Work Order Sent',
    VISIT_SCHEDULED: 'Visit Scheduled',
    WAITING_ON_CONTRACT: 'Waiting on Contract',
    WAITING_ON_BID: 'Waiting on Bid',
    RECEIVED: 'Received',
};
exports.WORK_ORDER_BID_ACCEPTED_STATUS = {
    ACCEPTED: 'Accepted',
    DECLINED: 'Declined',
    OPEN: 'Open',
};
//# sourceMappingURL=work-order-bid.types.js.map